import { Button } from "@/components/ui/button";
import { X, Check, Loader2 } from "lucide-react";
import { DialogFooter } from "@/components/ui/dialog";

interface DialogActionsProps {
  isLoading: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export function DialogActions({ isLoading, onCancel, onSave }: DialogActionsProps) {
  return (
    <DialogFooter className="flex justify-end gap-2">
      <Button
        variant="outline"
        onClick={onCancel}
        disabled={isLoading}
      >
        <X className="mr-2 h-4 w-4" />
        Annuler
      </Button>
      <Button
        onClick={onSave}
        disabled={isLoading}
      >
        {isLoading ? (
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        ) : (
          <Check className="mr-2 h-4 w-4" />
        )}
        Enregistrer
      </Button>
    </DialogFooter>
  );
}